import { render, staticRenderFns } from "./LoadObjects.vue?vue&type=template&id=35f8db53"
import script from "./LoadObjects.vue?vue&type=script&lang=js"
export * from "./LoadObjects.vue?vue&type=script&lang=js"
import style0 from "./LoadObjects.vue?vue&type=style&index=0&id=35f8db53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports